import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import CategoryHeading from '@fuww/components/src/CategoryHeading';
import SpacingContainer
from '@fuww/components/src/SpacingContainer';
import withQuery from '../../../../../lib/withQuery';
import NewsList from '../..';
import SiteContext from '../../../../SiteContext';
import messages from '../../../../../lib/messages';
import getArticlesQuery from '../../../../../lib/queries/news/getArticlesQuery';
import getArticlesField from '../../../../../lib/queries/news/getArticlesField';
import { newsListImageConfigurations }
from '../../../../../lib/imageConfigurations';
import { featuredCategoryIds } from '../../../../../lib/mainCategoryIds';

const MoreNews = ({
  data,
  field,
  categoryHeadline,
  showImage,
  showCategory,
  noBorderFirstItem,
}) => {
  const articles = data[field];
  const intl = useIntl();

  return (
    <>
      {categoryHeadline
        && (
          <>
            <CategoryHeading>
              {intl.formatMessage(messages.moreNews)}
            </CategoryHeading>
            <SpacingContainer />
          </>
        )}
      <NewsList
        newsArticles={articles}
        showImage={showImage}
        showCategory={showCategory}
        noBorderFirstItem={noBorderFirstItem}
      />
    </>
  );
};

MoreNews.propTypes = {
  data: PropTypes.shape({}),
  field: PropTypes.string.isRequired,
  categoryHeadline: PropTypes.bool,
  showCategory: PropTypes.bool,
  showImage: PropTypes.bool,
  noBorderFirstItem: PropTypes.bool,
};

MoreNews.defaultProps = {
  data: {},
  categoryHeadline: true,
  showImage: null,
  showCategory: null,
  noBorderFirstItem: null,
};

const MoreNewsWithQuery = withQuery(MoreNews);

const errorMessage = 'Error while loading news articles...';

const MoreNewsWithData = ({
  categoryHeadline,
  variables,
  limit,
  categoryIds,
  offset,
  showCategory,
  showImage,
  noBorderFirstItem,
  newsSection,
}) => {
  const { prefix, hasLocalNews, newsboard } = useContext(SiteContext);

  const field = getArticlesField(prefix, hasLocalNews);
  const query = getArticlesQuery(field, newsSection);
  const moreNewsVariables = {
    sort: 'CREATED_AT',
    limit,
    newsboards: [newsboard],
    categoryIds,
    offset,
    featured: false,
    imageConfigurations: newsListImageConfigurations,
    ...variables,
  };

  return (
    <MoreNewsWithQuery
      query={query}
      variables={moreNewsVariables}
      errorMessage={errorMessage}
      field={field}
      categoryHeadline={categoryHeadline}
      showImage={showImage}
      showCategory={showCategory}
      noBorderFirstItem={noBorderFirstItem}
    />
  );
};

MoreNewsWithData.propTypes = {
  categoryHeadline: PropTypes.bool,
  variables: PropTypes.shape({}),
  limit: PropTypes.number,
  categoryIds: PropTypes.arrayOf(PropTypes.number),
  offset: PropTypes.number,
  showCategory: PropTypes.bool,
  newsSection: PropTypes.string,
  showImage: PropTypes.bool,
  noBorderFirstItem: PropTypes.bool,
};

MoreNewsWithData.defaultProps = {
  categoryHeadline: true,
  variables: null,
  limit: 3,
  categoryIds: featuredCategoryIds,
  offset: 0,
  showImage: null,
  showCategory: null,
  noBorderFirstItem: null,
  newsSection: null,
};

export default MoreNewsWithData;
